import api from "@/api";

const urlBase64ToUint8Array = (b64) => {
  const padding = "=".repeat((4 - (b64.length % 4)) % 4);
  const base64 = (b64 + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) arr[i] = raw.charCodeAt(i);
  return arr;
};

export const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches ||
  window.navigator.standalone === true;

export const isPushSupported = () =>
  "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export const getNotificationPermission = () =>
  isPushSupported() ? Notification.permission : "denied";

export const subscribeToPush = async () => {
  if (!isPushSupported()) throw new Error("Push non supportato");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Permesso negato");
  const reg = await navigator.serviceWorker.ready;
  const publicKey =
    process.env.REACT_APP_VAPID_PUBLIC_KEY ||
    (await api.get("/push/vapid-public-key").then((r) => r.data.public_key));
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });
  }
  await api.post("/push/subscribe", { subscription: sub.toJSON() });
  return sub;
};

export const unsubscribeFromPush = async () => {
  if (!isPushSupported()) return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    await api.post("/push/unsubscribe", { subscription: sub.toJSON() });
    await sub.unsubscribe();
  }
};
